import versionData from '../version.json';

/**
 * VersionInfo Component
 * Very subtle version display showing git commit hash in the center bottom
 * Shows build date in tooltip on hover
 */
export default function VersionInfo() {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('da-DK', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="fixed bottom-3 left-1/2 transform -translate-x-1/2 z-50">
      <div
        className="px-2 py-0.5 bg-white/30 backdrop-blur-sm rounded text-[10px] font-mono text-gray-700 hover:text-gray-900 hover:bg-white/40 transition-all duration-200 cursor-help"
        title={`Bygget: ${formatDate(versionData.buildDate)}`}
      >
        {versionData.shortHash}
      </div>
    </div>
  );
}
